import type { InitOptions } from 'i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import HttpBackend from 'i18next-http-backend';
import { nameSpaces } from './client';

export enum Language {
  NL = 'nl',
  FR = 'fr'
}

export const languageMapping = {
  [Language.FR]: { language: 'fr-FR', cmsMapping: 'fr' },
  [Language.NL]: { language: 'nl-NL', cmsMapping: 'nl' }
};

export const languageReverseMapper: Record<string, Language> = {
  fr: Language.FR,
  nl: Language.NL
};

export enum Currency {
  EUR = 'EUR'
}

export enum ConfigUrlParams {
  LANGUAGE = 'lng',
  CURRENCY = 'cur'
}

export const currency = Object.values(Currency);

export const fallbackLng = Language.NL;

export const fallbackCurrency = Currency.EUR;

export const languages = Object.values(Language);

export function getOptionsClient(
  lng: string = fallbackLng,
  ns?: string | string[],
  isLocal?: string,
  magnoliaHost?: string,
  translationsVersion?: string
): InitOptions {
  return {
    // debug: process.env.NODE_ENV === 'development',
    debug: false,
    compatibilityJSON: 'v4',
    preload: typeof window === 'undefined' ? [...languages] : [],
    supportedLngs: [lng],
    fallbackLng: false,
    lng,
    fallbackNS: false,
    load: 'currentOnly',
    initImmediate: true,
    interpolation: { escapeValue: true },
    backend: {
      backends: [
        ...(isLocal !== 'true' ? [LocalStorageBackend, HttpBackend] : []),
        resourcesToBackend(
          (lng: string, ns: string) =>
            import(`../../../public/translations/generated/${lng}/${ns}.json`)
        )
      ],
      backendOptions: [
        {
          expirationTime: 10 * 60 * 1000,
          defaultVersion: translationsVersion
        },
        {
          loadPath: `${magnoliaHost}/.rest/translations/{{ns}}.{{lng}}.json`,
          reloadInterval: 10 * 60 * 1000,
          expirationTime: 10 * 60 * 1000,
          queryStringParams: { v: translationsVersion }
        }
      ]
    },
    ns: ns || nameSpaces
  };
}
